/**
 * The four loading-state timing values, stated once.
 *
 * docs/platform-standards.md §14 defines what each one means; this module is
 * the only place the numbers live. A surface imports them and never writes
 * its own, so changing a timing is one edit here.
 */

/** Wait this long before showing any loading indicator, so a fast answer never flashes one. */
export const LOADING_DELAY_MS = 150;

/** Once an indicator shows, keep it at least this long, so it never flickers away. */
export const LOADING_MIN_VISIBLE_MS = 300;

/** Past this, add a text hint ("Still loading") beside the indicator. */
export const LOADING_HINT_MS = 3000;

/** Past this, stop waiting: show an error with a retry. */
export const LOADING_TIMEOUT_MS = 30000;

export const LOADING_TIMING = Object.freeze({
	delay: LOADING_DELAY_MS,
	minVisible: LOADING_MIN_VISIBLE_MS,
	hint: LOADING_HINT_MS,
	timeout: LOADING_TIMEOUT_MS,
});
